import { addDays } from 'date-fns';
import type { SearchType } from '../../types';
import type { DateCell } from './types';
import type { VacationOptions } from './state';
import { getMidnightFromString } from '../../../../utils';
import { OFFSET_TIMEZONE_MSK, START_EVENING_HOUR } from './constants';
import { SEARCH_TYPE_NAMES } from '../../constants';

/* Возвращает диапазон дат покрывающий выбранную начальную дату и кол-во ночей */
export const convertVacationOptionsToDates = ({
  startDateCell,
  startDatePreset,
  nightsPreset,
  nights,
  shift,
}: VacationOptions & { startDateCell: DateCell; shift: number }): {
  startDate: Date | null;
  endDate: Date | null;
} => {
  const { date: startDate } = startDateCell;

  if ((!startDate && !startDatePreset) || (!nights && !nightsPreset)) {
    return {
      startDate: null,
      endDate: null,
    };
  }

  const maxNights = nights?.to || nightsPreset?.value.to || 0;

  const minStartDate = startDatePreset
    ? new Date(getMidnightFromString(startDatePreset.value.from.toString()))
    : addDays(startDate as Date, -shift);

  const maxStartDate = startDatePreset
    ? new Date(getMidnightFromString(startDatePreset.value.to.toString()))
    : addDays(startDate as Date, shift);

  const maxEndDate = addDays(maxStartDate as Date, maxNights);

  return {
    startDate: minStartDate,
    endDate: maxEndDate,
  };
};

/* Минимальная дата для выбора в календаре */
export const calcMinDate = (searchType: SearchType): Date => {
  /*
   * Внимание!
   * Тут необходимо брать модуль от часов, потому что по UTC полночь это 21:00:00 и если делать + 3 то просто будет 24, что некорректно
   * должно быть 0 и тогда равенство будет работать корректно
   */
  const isEvening = (new Date().getUTCHours() + OFFSET_TIMEZONE_MSK) % 24 >= START_EVENING_HOUR;
  const now = new Date();
  const currentDayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const minDateTour = addDays(currentDayMidnight, isEvening ? 2 : 1);
  const minDate = searchType === SEARCH_TYPE_NAMES.PACKAGE ? minDateTour : currentDayMidnight;

  return minDate;
};
